import { render, staticRenderFns } from "./UkrposhtaBtn.vue?vue&type=template&id=4d6e3c79"
import script from "./UkrposhtaBtn.vue?vue&type=script&lang=js"
export * from "./UkrposhtaBtn.vue?vue&type=script&lang=js"
import style0 from "./UkrposhtaBtn.vue?vue&type=style&index=0&id=4d6e3c79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports